import {
  Component,
  computed,
  input,
} from '@angular/core'
import { MatIcon } from '@angular/material/icon'

type ButtonType = 'primary' | 'secondary' | 'success' | 'danger'

@Component({
  selector: 'button[app-editable-table-toolbar-button]',
  imports: [MatIcon],
  host: {
    type: 'button',
    '[disabled]': 'disabled()',
    '[class]': 'classes()',
  },
  template: `
    @if (label()) {
      <span class='label'>{{ label() }}</span>
    }
    @if (icon()) {
      <mat-icon [fontIcon]="icon()!" />
    }
  `,
  styles: `
    :host {
      padding: 0 6px 0 6px;

      mat-icon {
        height: 22px;
        position: relative;
        top: 2px;
      }
    }
  `,
})
export class EditableTableToolbarButtonComponent {
  readonly disabled = input(false)
  readonly btnType = input<ButtonType>('secondary')
  readonly label = input<string>()
  readonly icon = input<string>()

  readonly classes = computed((): string => `btn btn-sm btn-outline-${this.disabled() ? 'secondary' : this.btnType()}`)
}
